<!--
minicart
AT
15.06.21
-->

<svelte:window
	on:dataUpdated={getData}
	on:cartUpdated={getData}
/>

<script>
	import SvgSprite from '../_shared/components/svg-sprite.svelte'
	export let data = { 'price':'', 'quantity':'', 'approximative':'' }

	function getData(e){
		switch(e.type) {
			case 'dataUpdated':
				data = e.detail.cart || {}
			break
			case 'cartUpdated':
				data = e.detail
		}
	}

</script>

<button class="simple fit-input flex flex-center flex-middle" data-modal='#modal-cart'>
	<SvgSprite symbol="cart" css="L icon"/>
	{ #if data.quantity>0 }
		{ data.quantity }
	{ /if }
	{ #if data.price>0 }
		/ { data.approximative }{ data.price } ₽
	{ /if }
</button>